import { createSlice } from '@reduxjs/toolkit'
import {
  requestChangePath,
  setConfirmLeavePage,
  setRouterPath,
} from '@wellesley/host-remote/api/actions'
import { rootReducer } from '@wellesley/store'

type RouterState = {
  path: string
  history: string[]
  transitionPath: string
  confirmLeavePage: {
    shouldBlock: boolean
    message: string
  } | null
}

const initialState: RouterState = {
  path: '',
  history: [],
  transitionPath: '',
  confirmLeavePage: null,
}

export const routerSlice = createSlice({
  name: 'router',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setConfirmLeavePage, (state, { payload }) => {
        state.confirmLeavePage = payload
      })
      .addCase(requestChangePath, (state, { payload }) => {
        if (payload !== state.transitionPath) {
          state.transitionPath = payload
        }
      })
      .addCase(setRouterPath, (state, { payload }) => {
        if (payload !== state.path) {
          state.path = payload
          state.history.unshift(payload)
        }
      })
  },
  selectors: {
    selectPath: (state) => state.path,
    selectPreviousRoute: (state) => {
      const index = state.history.indexOf(state.path)
      const previousRoute = state.history[index + 1]

      return previousRoute
    },
    selectTransitionPath: (state) => state.transitionPath,
    selectConfirmLeavePage: (state) => state.confirmLeavePage,
  },
}).injectInto(rootReducer)
